/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_vol_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because a 'cup' isn't a round number in milliliters (236.588 mL), and many recipe sites additionally round it to 240 or 250 mL for convenience. For baking, where ratios matter more than exact volume, either rounding is normally fine; for precise lab or bar measurements, use the unrounded value.`)
};

const es_uc_vol_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque una 'taza' no es un número redondo en mililitros (236.588 mL), y muchos sitios de recetas además la redondean a 240 o 250 mL por conveniencia. Para horneado, donde las proporciones importan más que el volumen exacto, cualquiera redondeo normalmente está bien; para medidas de laboratorio o barra precisas, usa el valor no redondeado.`)
};

const de_uc_vol_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weil ein 'Cup' in Millilitern keine runde Zahl ist (236.588 mL), und viele Rezeptseiten runden ihn zusätzlich der Einfachheit halber auf 240 oder 250 mL. Beim Backen, wo Verhältnisse wichtiger sind als das exakte Volumen, ist beide Rundung normalerweise unproblematisch; für präzise Labor- oder Bar-Messungen verwenden Sie den ungerundeten Wert.`)
};

const nl_uc_vol_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omdat een 'kopje' geen rond getal in milliliters is (236.588 mL), en veel receptsites ronden dit bovendien naar 240 of 250 mL voor gemak af. Voor bakken, waar verhoudingen meer uitmaken dan exact volume, is afronding normaal prima; voor nauwkeurige laboratorium- of barmetingen, gebruik de niet-afgeronde waarde.`)
};

const fr_uc_vol_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parce qu'une 'tasse' n'est pas un nombre rond en millilitres (236,588 mL), et de nombreux sites de recettes l'arrondissent de plus en 240 ou 250 mL pour commodité. Pour la cuisson, où les proportions importent plus que le volume exact, l'un ou l'autre arrondi est normalement bon ; pour les mesures précises de laboratoire ou de bar, utilisez la valeur non arrondie.`)
};

const it_uc_vol_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché una 'tazza' non è un numero rotondo in millilitri (236,588 mL), e molti siti di ricette inoltre l'arrotondano a 240 o 250 mL per comodità. Per la cottura, dove i rapporti importano più del volume esatto, entrambi gli arrotondamenti sono normalmente va bene; per misurazioni precise di laboratorio o bar, usa il valore non arrotondato.`)
};

const pt_br2_uc_vol_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque uma 'xícara' não é um número redondo em mililitros (236.588 mL), e muitos sites de receitas adicionalmente arredondam para 240 ou 250 mL por conveniência. Para assar, onde proporções importam mais do que volume exato, qualquer arredondamento é normalmente bom; para medições de laboratório ou bar precisas, use o valor não arredondado.`)
};

const pt_uc_vol_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque uma 'chávena' não é um número redondo em mililitros (236,588 mL), e muitos sites de receitas adicionalmente arredondam para 240 ou 250 mL por conveniência. Para cozimento, onde as razões importam mais do que o volume exacto, qualquer arredondamento é normalmente bem; para medições precisas de laboratório ou bar, utilize o valor não arredondado.`)
};

const ja_uc_vol_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「カップ」はミリリットルで丸い数(236.588 mL)ではなく、多くのレシピサイトは利便性のため240または250 mL にそれをさらに丸めるため。比率が正確な体積より重要である焙烤のため、どちらかの丸めは通常は問題ありません。正確なラボまたはバー測定のため、丸められていない値を使用します。`)
};

const zh_uc_vol_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_vol_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_vol_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_vol_faq4_a", locale)
	if (locale === "en") return en_uc_vol_faq4_a(inputs)
	if (locale === "es") return es_uc_vol_faq4_a(inputs)
	if (locale === "de") return de_uc_vol_faq4_a(inputs)
	if (locale === "nl") return nl_uc_vol_faq4_a(inputs)
	if (locale === "fr") return fr_uc_vol_faq4_a(inputs)
	if (locale === "it") return it_uc_vol_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_vol_faq4_a(inputs)
	if (locale === "pt") return pt_uc_vol_faq4_a(inputs)
	if (locale === "ja") return ja_uc_vol_faq4_a(inputs)
	return zh_uc_vol_faq4_a(inputs)
};